import React from "react";
import { Label } from "Application";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { StatusBox } from "./SessionReport.styles";
import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { isEmptyOrWhitespace } from "@shoothill/core";
import { GoToPath } from "Views/Students/Student/StudentTargets/Shared/Components/GoToPath";

const Container = styled.div`
    position: relative;
`;

const BarContainer = styled.div`
    position: relative;
`;

const TitleContainer = styled.div`
    position: absolute;
    top: -50px;
    left: 30px;
    z-index: 4;
`;

const StatusBoxContainer = styled.div`
    position: absolute;
    top: 50%;
    right: 30px;
    transform: translateY(-50%);
`;

export const SessionReportHeader: React.FC<{ viewModel: IStudentSessionReportViewModel }> = observer(({ viewModel }) => (
    <Container>
        <TitleContainer>
            <Label fontStyle="h1">Session Report</Label>
        </TitleContainer>
        <BarContainer>
            <GoToPath name="session reports" path={viewModel.backPath} />
            <StatusBoxContainer>
                <StatusBox hasId={!!viewModel.model.id && !isEmptyOrWhitespace(viewModel.model.sessionStatusId)}>
                    {viewModel.model.id && !isEmptyOrWhitespace(viewModel.model.sessionStatusId) ? viewModel.getSessionStatusById(viewModel.model.sessionStatusId) : "PENDING"}
                </StatusBox>
            </StatusBoxContainer>
        </BarContainer>
    </Container>
));
